<template>
 
  <div>Download</div>
</template>

<script>

export default {
  name: 'DownloadView',
   components: {

  },
}
</script>


<style>

</style>